document.addEventListener('DOMContentLoaded', () => {
  const megaItems = document.querySelectorAll('.has-mega-menu');

  megaItems.forEach((item) => {
    const trigger = item.querySelector('.site-header__mega-trigger');
    if (!trigger) return;

    let closeTimer = null;

    const open = () => {
      clearTimeout(closeTimer);
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      closeTimer = setTimeout(() => {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }, 150);
    };

    // Desktop: hover to open/close.
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);

    // All devices: click/tap toggles, so it works without hover (touch, keyboard).
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = item.classList.contains('is-open');
      megaItems.forEach((other) => {
        other.classList.remove('is-open');
        other.querySelector('.site-header__mega-trigger')?.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) open();
    });

    // Close on Escape or click outside.
    document.addEventListener('click', (e) => {
      if (!item.contains(e.target)) {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });
});